import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme-revamp';

const TooltipContent = styled.div<{theme: ITheme}>`
  p {
    color: ${props => props.theme.colors.primary};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: 0.015;
    span {
      font-weight: 600;
      color: ${props => props.theme.colors.primary};
    }
  }

  h4 {
    color: ${props => props.theme.colors.primary};
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
  }
  ul {
    li {
     color: ${props => props.theme.colors.grey[1400]};
     font-size: 14px;
     font-weight: 400;
     line-height: 1.8;
     list-style: none;
    }
  }
  @media screen and (min-width: 768px) {
    ul {
      li {
       color: ${props => props.theme.colors.grey[1400]};
       font-size: 14px;
       font-weight: 500;
       line-height: 1.8;
       list-style: none;
      }
    }

    p {
      color: ${props => props.theme.colors.grey[1400]};
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      letter-spacing: 0.015;
      span {
        font-weight: 600;
        color: ${props => props.theme.colors.primary};
      }
    }
  }
`;


const TootipPointer = styled.div<{variant:String}>`
  width: 72px;
  height: 38px;
  overflow: hidden;
  position: absolute;
  top: ${props=>props.variant === 'top' ? '-45px' : 'unset'};
  bottom: ${props=>props.variant === 'top' ? 'unset' : '-45px'};
  
  left: 32px;
  transform:  ${props=>props.variant === 'top' ? 'scaleY(1.5)': 'scaleY(1.5) rotate(180deg)'};
  &:after {
    content: '';
    background-color: #fff;
    border-radius: 10px 0 0 0;
    box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.1);
    position: absolute;
    transform: rotate(45deg);
    position: absolute;
    top: 20px;
    left: 16px;
    right: 16px;
    height: 40px;
    z-index: 1;
  }
`;

const TooltipContainer = styled.div<{maxWidth:number, variant:String, contentHeight:number }>`
  margin-top: ${props => props.variant === 'top' ? '38px' : `unset`};;
  display: inline-block;
  padding: 36px;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + 'px' : 'unset')};
  box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  position: relative;
  background-color: #fff;
  transform: ${props => props.variant === 'top' ? 'unset' : `translateY(-${props.contentHeight}px)`};
`;

export interface TooltipProps {
  children: JSX.Element;
  maxWidth: number;
  theme: ITheme;
  variant?: 'top' | 'bottom';
}

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, variant='top',...props }: TooltipProps, ref) => {
    const theme = useTheme();
    
    const ToolTipContainerRef = useRef<HTMLDivElement>(null);
    const [contentHeight, setContentHeight] = useState<number>(0);
    const arrowHeight = 38;

    useEffect(() => {
      if (!contentHeight && ToolTipContainerRef.current) {
        setContentHeight(ToolTipContainerRef.current?.offsetHeight + arrowHeight);
      }
    }, [contentHeight]);

    return (
      <TooltipContainer variant={variant} contentHeight={contentHeight} ref={ToolTipContainerRef} {...props}>
        <TootipPointer variant={variant}></TootipPointer>
        <TooltipContent theme={theme}>
          {children}
        </TooltipContent>
      </TooltipContainer>
    );
  }
);

Tooltip.defaultProps = {};
export { Tooltip };
